export type ThemeId =
  | 'hmh-dark'
  | 'hmh-light'
  | 'editorial-dark'
  | 'editorial-light'
  | 'nordic'
  | 'reader'
  | 'solarized'
  | 'midnight'
  | 'forest'
  | 'system';

export type Theme = {
  id: ThemeId;
  name: string;
  mode: 'light' | 'dark' | 'auto';
  description: string;
  preview: { surface: string; accent: string; text: string };
};

export const themes: Theme[] = [
  {
    id: 'hmh-dark',
    name: 'HMH Dark',
    mode: 'dark',
    description: 'Official HMH identity on dark — brand blue, Helvetica.',
    preview: { surface: '#141418', accent: '#858ac4', text: '#ffffff' },
  },
  {
    id: 'hmh-light',
    name: 'HMH Light',
    mode: 'light',
    description: 'Official HMH identity — corporate blue, red, grey, Helvetica.',
    preview: { surface: '#ffffff', accent: '#334b9b', text: '#000000' },
  },
  {
    id: 'editorial-dark',
    name: 'Editorial Dark',
    mode: 'dark',
    description: 'Serif editorial — Playfair + PT Serif, green accent.',
    preview: { surface: '#242427', accent: '#3dc372', text: '#f4f4f6' },
  },
  {
    id: 'editorial-light',
    name: 'Editorial Light',
    mode: 'light',
    description: 'Warm paper — same serif stack, inverted palette.',
    preview: { surface: '#f7f5f0', accent: '#2a9f59', text: '#1a1a1d' },
  },
  {
    id: 'nordic',
    name: 'Nordic',
    mode: 'light',
    description: 'Scandinavian calm — Inter + Plex Serif, slate blue.',
    preview: { surface: '#eef2f5', accent: '#4c6f8c', text: '#1c2633' },
  },
  {
    id: 'reader',
    name: 'Reader',
    mode: 'light',
    description: 'Pure black on white — maximum legibility.',
    preview: { surface: '#ffffff', accent: '#475569', text: '#000000' },
  },
  {
    id: 'solarized',
    name: 'Solarized',
    mode: 'light',
    description: "Ethan Schoonover's cream + teal palette.",
    preview: { surface: '#fdf6e3', accent: '#2aa198', text: '#586e75' },
  },
  {
    id: 'midnight',
    name: 'Midnight',
    mode: 'dark',
    description: 'Near-black OLED-friendly, violet accent.',
    preview: { surface: '#111114', accent: '#a78bfa', text: '#e6e6ea' },
  },
  {
    id: 'forest',
    name: 'Forest',
    mode: 'dark',
    description: 'Olive + earth tones, sage accent.',
    preview: { surface: '#23251e', accent: '#8faf6d', text: '#e8e9e0' },
  },
  {
    id: 'system',
    name: 'System',
    mode: 'auto',
    description: 'Follows your OS — HMH Dark or HMH Light.',
    preview: { surface: 'linear-gradient(135deg, #141418 50%, #ffffff 50%)', accent: '#334b9b', text: '#ffffff' },
  },
];

export const DEFAULT_THEME: ThemeId = 'hmh-light';
